'use strict';

var darkDesktop1280;
var hasRequiredDarkDesktop1280;

function requireDarkDesktop1280 () {
	if (hasRequiredDarkDesktop1280) return darkDesktop1280;
	hasRequiredDarkDesktop1280 = 1;

	/**
	 * Do not edit directly, this file was auto-generated.
	 */

	darkDesktop1280 = {
	  "theme": "dark-desktop1280",
	  "type": {
	    "family": {
	      "base": "Mulish",
	      "decorative": "Besley"
	    }
	  },
	  "borderWeight": {
	    "medium": "2px",
	    "small": "1.5px",
	    "xsmall": "1px"
	  },
	  "column": {
	    "app": {
	      "container": "0px",
	      "gutter": "0px",
	      "margin": "0px"
	    },
	    "web": {
	      "container": "1440px",
	      "gutter": "16px",
	      "margin": "32px"
	    }
	  },
	  "gap": {
	    "0": "0px",
	    "25": "1px",
	    "50": "2px",
	    "100": "4px",
	    "200": "8px",
	    "300": "12px",
	    "400": "16px",
	    "500": "20px",
	    "600": "24px",
	    "800": "32px",
	    "1000": "32px",
	    "1200": "48px",
	    "1600": "64px",
	    "3600": "144px"
	  },
	  "padding": {
	    "dynamic": {
	      "200": "8px",
	      "400": "16px",
	      "600": "24px",
	      "800": "32px",
	      "1000": "40px",
	      "1200": "48px"
	    },
	    "static": {
	      "25": "1px",
	      "50": "2px",
	      "100": "4px",
	      "150": "4px",
	      "200": "8px",
	      "300": "12px",
	      "400": "16px",
	      "500": "20px",
	      "600": "24px",
	      "800": "32px",
	      "1000": "40px",
	      "1200": "48px",
	      "1400": "56px",
	      "1600": "64px",
	      "4125": "0px"
	    }
	  },
	  "radius": {
	    "background": {
	      "large": "16px",
	      "medium": "8px",
	      "rounded": "300px",
	      "small": "4px",
	      "xlarge": "32px",
	      "xsmall": "3px"
	    },
	    "surface": {
	      "large": "16px",
	      "medium": "8px",
	      "small": "4px",
	      "xlarge": "32px"
	    }
	  },
	  "size": {
	    "height": {
	      "25": "1px",
	      "75": "3px",
	      "100": "4px",
	      "150": "6px",
	      "200": "8px",
	      "300": "12px",
	      "350": "14px",
	      "400": "16px",
	      "450": "18px",
	      "475": "19px",
	      "500": "20px",
	      "525": "21px",
	      "600": "24px",
	      "675": "27px",
	      "700": "28px",
	      "800": "32px",
	      "850": "34px",
	      "1000": "40px",
	      "1050": "42px",
	      "1100": "44px",
	      "1300": "52px",
	      "1400": "56px",
	      "1550": "62px",
	      "1600": "64px",
	      "2000": "80px",
	      "2200": "88px",
	      "2750": "110px",
	      "3000": "120px",
	      "3650": "146px",
	      "4000": "160px",
	      "5000": "200px",
	      "5600": "224px",
	      "8375": "335px",
	      "14600": "584px",
	      "146003": "584px"
	    },
	    "width": {
	      "25": "1px",
	      "150": "6px",
	      "200": "8px",
	      "300": "12px",
	      "350": "14px",
	      "400": "16px",
	      "450": "18px",
	      "500": "20px",
	      "600": "24px",
	      "700": "28px",
	      "800": "32px",
	      "850": "34px",
	      "950": "38px",
	      "1000": "40px",
	      "1050": "42px",
	      "1100": "44px",
	      "1300": "52px",
	      "1400": "56px",
	      "1550": "62px",
	      "1600": "64px",
	      "2000": "80px",
	      "2200": "88px",
	      "2350": "94px",
	      "2750": "110px",
	      "3000": "120px",
	      "3650": "146px",
	      "4000": "160px",
	      "5000": "200px",
	      "5250": "210px",
	      "5600": "224px",
	      "6500": "260px",
	      "7500": "300px",
	      "8375": "335px",
	      "14600": "584px"
	    }
	  },
	  "asset": {
	    "blue": {
	      "100": "#0c1b29",
	      "200": "#102841",
	      "300": "#1a3c60",
	      "400": "#4577ad",
	      "500": "#6597ce",
	      "600": "#96bde7",
	      "700": "#d1e8ff",
	      "800": "#e6f1fc",
	      "900": "#ffffff",
	      "background": "#1a3c60",
	      "backItem": "#285685"
	    },
	    "green": {
	      "100": "#0c291e",
	      "200": "#124935",
	      "300": "#1f5b45",
	      "400": "#288563",
	      "500": "#42ad86",
	      "600": "#bfe8d9",
	      "700": "#f0fff9",
	      "800": "#fafffc",
	      "900": "#ffffff",
	      "background": "#1f5b45",
	      "backItem": "#206a4f"
	    },
	    "grey": {
	      "100": "#141719",
	      "200": "#1d2124",
	      "300": "#515357",
	      "400": "#2d3238",
	      "500": "#98999b",
	      "600": "#bcbdbf",
	      "700": "#e8e9ea",
	      "800": "#f7f7f7",
	      "900": "#ffffff",
	      "background": "#515357",
	      "backItem": "#22272b"
	    },
	    "orange": {
	      "100": "#29170c",
	      "200": "#4a2915",
	      "300": "#63371c",
	      "400": "#ad6234",
	      "500": "#cf7945",
	      "600": "#e7aa84",
	      "700": "#ffe3d1",
	      "800": "#fff3e8",
	      "900": "#ffffff",
	      "background": "#63371c",
	      "backItem": "#8a4e29"
	    },
	    "purple": {
	      "100": "#200f29",
	      "200": "#33193f",
	      "300": "#482359",
	      "400": "#865c99",
	      "500": "#b990cc",
	      "600": "#d8b1ec",
	      "700": "#f0d1ff",
	      "800": "#f2ecfe",
	      "900": "#ffffff",
	      "background": "#482359",
	      "backItem": "#693b80"
	    },
	    "red": {
	      "100": "#290f16",
	      "200": "#451522",
	      "300": "#5e1d2e",
	      "400": "#b23655",
	      "500": "#c74c6b",
	      "600": "#ea8aa3",
	      "700": "#ffd1dd",
	      "800": "#feeef2",
	      "900": "#ffffff",
	      "background": "#5e1d2e",
	      "backItem": "#8f2843"
	    },
	    "sand": {
	      "100": "#000000",
	      "200": "#493612",
	      "300": "#5e4317",
	      "400": "#8e703e",
	      "500": "#bba37c",
	      "600": "#e2d0ac",
	      "700": "#efe5d1",
	      "800": "#f6f1e5",
	      "900": "#ffffff",
	      "background": "#5e4317",
	      "backItem": "#6b5024"
	    },
	    "shade": {
	      "white": "#ffffff"
	    }
	  },
	  "accent": {
	    "blue": {
	      "backgroundBold": "#6597ce",
	      "backgroundLevel1": "#102841",
	      "backgroundLevel2": "#1a3c60",
	      "border": "#4577ad",
	      "icon": "#d1e8ff",
	      "text": "#d1e8ff",
	      "textBold": "#e6f1fc"
	    },
	    "green": {
	      "backgroundBold": "#42ad86",
	      "backgroundLevel1": "#124935",
	      "backgroundLevel2": "#1f5b45",
	      "border": "#f0fff9",
	      "borderBold": "#fafffc",
	      "icon": "#f0fff9",
	      "iconBold": "#fafffc",
	      "text": "#f0fff9",
	      "textBold": "#fafffc"
	    },
	    "orange": {
	      "backgroundBold": "#cf7945",
	      "backgroundLevel1": "#4a2915",
	      "backgroundLevel2": "#63371c",
	      "border": "#ad6234",
	      "icon": "#ffe3d1",
	      "text": "#ffe3d1",
	      "textBold": "#fff3e8"
	    },
	    "purple": {
	      "backgroundBold": "#b990cc",
	      "backgroundLevel1": "#33193f",
	      "backgroundLevel2": "#482359",
	      "border": "#865c99",
	      "icon": "#f0d1ff",
	      "text": "#f0d1ff",
	      "textBold": "#f2ecfe"
	    },
	    "red": {
	      "backgroundBold": "#ea8aa3",
	      "backgroundLevel1": "#451522",
	      "backgroundLevel2": "#5e1d2e",
	      "border": "#b23655",
	      "icon": "#ffd1dd",
	      "text": "#ffd1dd",
	      "textBold": "#feeef2"
	    }
	  },
	  "brand": {
	    "apple": {
	      "button": {
	        "border": "#ffffff",
	        "fill": "#ffffff",
	        "text": "#000000"
	      },
	      "icon": "#000000"
	    },
	    "emerson": {
	      "gold": "#dca270",
	      "silver": "#949494"
	    },
	    "facebook": {
	      "logo": "#3c5a99"
	    },
	    "fullscript": {
	      "logo": {
	        "leaf": "#88b04b",
	        "wordmark": "#ffffff"
	      }
	    },
	    "google": {
	      "button": {
	        "border": "#f2f2f2",
	        "fill": "#f2f2f2",
	        "text": "#1f1f1f"
	      },
	      "icon": {
	        "blue": "#4285f4",
	        "green": "#34a853",
	        "red": "#ea4335",
	        "yellow": "#fbbc05"
	      }
	    },
	    "linkedin": {
	      "logo": "#2867b2"
	    },
	    "twitterX": {
	      "logo": "#ffffff"
	    }
	  },
	  "critical": {
	    "backgroundBold": "#ea8aa3",
	    "backgroundLevel1": "#451522",
	    "backgroundLevel2": "#5e1d2e",
	    "border": "#b23655",
	    "icon": "#ffd1dd",
	    "text": "#ffd1dd",
	    "textBold": "#feeef2"
	  },
	  "discovery": {
	    "backgroundBold": "#bba37c",
	    "backgroundLevel1": "#493612",
	    "backgroundLevel2": "#5e4317",
	    "border": "#6b5024",
	    "icon": "#efe5d1",
	    "text": "#efe5d1",
	    "textBold": "#f6f1e5"
	  },
	  "info": {
	    "backgroundBold": "#6597ce",
	    "backgroundLevel1": "#102841",
	    "backgroundLevel2": "#1a3c60",
	    "border": "#4577ad",
	    "icon": "#d1e8ff",
	    "text": "#d1e8ff",
	    "textBold": "#e6f1fc"
	  },
	  "inverse": {
	    "backgroundBold": "#f7f7f7",
	    "backgroundMuted": "#e8e9ea",
	    "border": "#f7f7f7",
	    "borderBold": "#141719",
	    "icon": "#1d2124",
	    "iconBold": "#141719",
	    "text": "#1d2124",
	    "textBold": "#141719"
	  },
	  "neutral": {
	    "backgroundLevel0": "#141719",
	    "backgroundLevel1": "#1d2124",
	    "backgroundLevel2": "#2d3238",
	    "backgroundLevel3": "#515357",
	    "border": "#686b70",
	    "borderBold": "#98999b",
	    "borderMuted": "#1d2124",
	    "divider": "#515357",
	    "icon": "#e8e9ea",
	    "iconBold": "#e8e9ea",
	    "text": "#e8e9ea",
	    "textBold": "#ffffff",
	    "textSubtle": "#bcbdbf",
	    "backgroundLevel02": "#ffffff"
	  },
	  "recur": {
	    "backgroundBold": "#b990cc",
	    "backgroundLevel1": "#33193f",
	    "backgroundLevel2": "#482359",
	    "border": "#865c99",
	    "icon": "#f0d1ff",
	    "text": "#f0d1ff",
	    "textBold": "#f2ecfe"
	  },
	  "smart": {
	    "backgroundBold1": "#8fa7c1",
	    "backgroundBold2": "#b0c1d4",
	    "backgroundBold3": "#c8d6e4"
	  },
	  "success": {
	    "backgroundBold": "#42ad86",
	    "backgroundLevel1": "#124935",
	    "backgroundLevel2": "#1f5b45",
	    "border": "#288563",
	    "icon": "#f0fff9",
	    "text": "#f0fff9",
	    "textBold": "#fafffc"
	  },
	  "surface": {
	    "inverse": "#e8e9ea",
	    "level0": "#141719",
	    "level1": "#1d2124",
	    "overflow": "#2d3238",
	    "overlay": "#2d3238",
	    "overlayBackdrop": "#00000066",
	    "overlayInverted": "#e8e9ea",
	    "raised": "#2d3238"
	  },
	  "warning": {
	    "backgroundBold": "#cf7945",
	    "backgroundLevel1": "#4a2915",
	    "backgroundLevel2": "#63371c",
	    "border": "#ad6234",
	    "icon": "#ffe3d1",
	    "text": "#ffe3d1",
	    "textBold": "#fff3e8"
	  },
	  "effect": {
	    "blur": {
	      "price": "6px"
	    },
	    "elevation": {
	      "overflow": {
	        "blur": "4px",
	        "colour": "#14171999",
	        "opacity": "60px",
	        "spread": "0px",
	        "x": "0px",
	        "y": "-2px"
	      },
	      "overflowFade": "#141719",
	      "overlay": {
	        "blur": "16px",
	        "colour": "#14171999",
	        "opacity": "60px",
	        "spread": "0px",
	        "x": "0px",
	        "y": "8px"
	      },
	      "raised": {
	        "blur": "4px",
	        "colour": "#14171999",
	        "opacity": "60px",
	        "spread": "0px",
	        "x": "0px",
	        "y": "2px"
	      }
	    },
	    "focused": {
	      "border": "#015fcc",
	      "stroke": "2px"
	    },
	    "overlay": "#ffffff33",
	    "skeleton": {
	      "backgroundLevel0": "#1d212400",
	      "backgroundLevel1": "#22272b80",
	      "backgroundLevel2": "#2d3238",
	      "radius": "4px"
	    },
	    "state": {
	      "disabled": {
	        "opacity": "0.6"
	      },
	      "hovered": {
	        "background": "#ffffff14",
	        "backgroundBold": "#00000029",
	        "border": "#ffffff14",
	        "borderBold": "#ffffff47",
	        "icon": "#ffffff14",
	        "iconBold": "#00000029",
	        "inverse": {
	          "background": "#00000014",
	          "backgroundBold": "#00000029",
	          "border": "#00000014",
	          "borderBold": "#00000014",
	          "icon": "#00000014",
	          "text": "#00000014"
	        },
	        "text": "#ffffff14",
	        "textBold": "#00000029"
	      },
	      "pressed": {
	        "background": "#ffffff29",
	        "backgroundBold": "#00000047",
	        "border": "#ffffff29",
	        "borderBold": "#ffffffcc",
	        "icon": "#ffffff29",
	        "iconBold": "#00000047",
	        "inverse": {
	          "background": "#00000029",
	          "backgroundBold": "#00000047",
	          "border": "#00000029",
	          "borderBold": "#000000cc",
	          "icon": "#00000029",
	          "text": "#00000029"
	        },
	        "text": "#ffffff29",
	        "textBold": "#00000047"
	      },
	      "readOnly": {
	        "opacity": "0.8"
	      },
	      "shortPressed": {
	        "opacity": "0.6"
	      }
	    }
	  },
	  "typography": {
	    "letterSpacing": {
	      "body": "-0.2px",
	      "callout": "-0.2px",
	      "caption": "0px",
	      "footnote": "-0.1px",
	      "h1": "-0.4px",
	      "h2": "-0.4px",
	      "h3": "-0.4px",
	      "h4": "-0.4px",
	      "h5": "-0.4px",
	      "smallest": "0.1px",
	      "subcaption": "0.1px"
	    },
	    "lineHeight": {
	      "body": "24px",
	      "callout": "20px",
	      "caption": "16px",
	      "footnote": "20px",
	      "h1": "40px",
	      "h2": "32px",
	      "h3": "32px",
	      "h4": "24px",
	      "h5": "24px",
	      "smallest": "18px",
	      "subcaption": "16px"
	    },
	    "textSize": {
	      "body": "16px",
	      "callout": "15px",
	      "caption": "12px",
	      "footnote": "13px",
	      "h1": "27px",
	      "h2": "24px",
	      "h3": "22px",
	      "h4": "19px",
	      "h5": "17px",
	      "smallest": "9px",
	      "subcaption": "11px"
	    }
	  },
	  "weight": {
	    "bold": "700",
	    "medium": "500",
	    "regular": "400",
	    "semibold": "600"
	  },
	  "accordion": {
	    "border": "#686b70",
	    "borderRadius": "8px",
	    "gapX": "12px",
	    "gapY": "8px",
	    "paddingX": "16px",
	    "paddingY": "8px",
	    "showMoreButton": {
	      "gap": "8px",
	      "paddingX": "12px"
	    },
	    "showMore": {
	      "gap": "8px"
	    },
	    "text": "#ffffff"
	  },
	  "actionTile": {
	    "accentGreen": {
	      "background": "#124935",
	      "border": "#f0fff9",
	      "textBody": "#f0fff9",
	      "textHeading": "#fafffc"
	    },
	    "alternate": {
	      "background": "#141719"
	    },
	    "borderRadius": "8px",
	    "borderWeight": "1px",
	    "gap": "16px",
	    "neutral": {
	      "background": "#1d2124",
	      "border": "#686b70"
	    },
	    "paddingX": "16px",
	    "paddingY": "16px",
	    "textBody": "#e8e9ea",
	    "textHeading": "#ffffff"
	  },
	  "attachment": {
	    "border": "#686b70",
	    "borderRadius": "8px",
	    "borderWeight": "1px",
	    "gap": {
	      "medium": "16px",
	      "small": "8px"
	    },
	    "paddingX": "8px",
	    "paddingY": "8px",
	    "text": "#ffffff"
	  },
	  "avatar": {
	    "backgroundAvatar": "#2d3238",
	    "backgroundWellevate": "#102841",
	    "border": "#ffffff",
	    "borderWeight": "1px",
	    "gap": "8px",
	    "height": {
	      "large": "120px",
	      "medium": "80px",
	      "small": "56px",
	      "xlarge": "160px",
	      "xsmall": "40px"
	    },
	    "icon": {
	      "background": "#e8e9ea",
	      "height": "34px",
	      "iconInverse": "#1d2124",
	      "iconNeutral": "#e8e9ea",
	      "width": "34px"
	    },
	    "radius": "300px",
	    "text": "#ffffff",
	    "width": {
	      "large": "120px",
	      "medium": "80px",
	      "small": "56px",
	      "xlarge": "160px",
	      "xsmall": "40px"
	    }
	  },
	  "badge": {
	    "critical": {
	      "background": "#ea8aa3",
	      "text": "#1d2124"
	    },
	    "height": {
	      "medium": "20px",
	      "small": "12px",
	      "xsmall": "8px"
	    },
	    "inverse": {
	      "background": "#2d3238",
	      "text": "#e8e9ea"
	    },
	    "neutral": {
	      "background": "#f7f7f7",
	      "text": "#1d2124"
	    },
	    "paddingX": "4px",
	    "paddingY": "4px",
	    "radius": "300px",
	    "recur": {
	      "background": "#b990cc",
	      "text": "#1d2124"
	    },
	    "success": {
	      "background": "#42ad86",
	      "text": "#1d2124"
	    },
	    "warning": {
	      "background": "#cf7945",
	      "text": "#1d2124"
	    },
	    "width": {
	      "medium": "20px",
	      "small": "12px",
	      "xsmall": "8px"
	    }
	  },
	  "bottomSheet": {
	    "backgroundScrim": "#ffffff33",
	    "backgroundSheet": "#141719",
	    "gap": {
	      "large": "20px",
	      "medium": "8px",
	      "small": "4px"
	    },
	    "handle": {
	      "background": "#515357",
	      "borderRadius": "4px",
	      "height": "4px",
	      "width": "44px"
	    },
	    "item": {
	      "borderRadius": "4px",
	      "gap": "12px",
	      "height": "44px",
	      "paddingX": "8px",
	      "paddingY": "12px",
	      "title": "#ffffff"
	    },
	    "paddingX": {
	      "large": "40px",
	      "medium": "20px",
	      "small": "4px"
	    },
	    "paddingY": {
	      "medium": "20px",
	      "small": "16px"
	    },
	    "radius": "32px",
	    "textSubtitle": "#bcbdbf",
	    "textTitle": "#e8e9ea"
	  },
	  "box": {
	    "alternate": {
	      "background": "#141719",
	      "border": "#686b70"
	    },
	    "borderRadius": "8px",
	    "borderWeight": "1px",
	    "discovery": {
	      "background": "#493612",
	      "border": "#6b5024"
	    },
	    "neutral": {
	      "background": "#1d2124",
	      "border": "#686b70"
	    },
	    "paddingX": {
	      "large": "32px",
	      "small": "16px",
	      "xsmall": "8px"
	    },
	    "paddingY": {
	      "large": "32px",
	      "small": "16px",
	      "xsmall": "8px"
	    },
	    "recur": {
	      "background": "#33193f",
	      "border": "#865c99"
	    }
	  },
	  "button": {
	    "borderRadius": {
	      "medium": "8px",
	      "small": "4px"
	    },
	    "borderWeight": "1px",
	    "gap": {
	      "medium": "16px",
	      "small": "8px"
	    },
	    "height": {
	      "large": "52px",
	      "medium": "44px",
	      "small": "34px"
	    },
	    "paddingL": "16px",
	    "paddingX": {
	      "small": "16px"
	    },
	    "primary": {
	      "critical": {
	        "background": "#ea8aa3",
	        "icon": "#1d2124",
	        "text": "#141719"
	      },
	      "inverse": {
	        "background": "#1d2124",
	        "border": "#98999b",
	        "icon": "#e8e9ea",
	        "text": "#ffffff"
	      },
	      "neutral": {
	        "background": "#e8e9ea",
	        "border": "#141719",
	        "icon": "#1d2124",
	        "text": "#141719"
	      },
	      "smart": {
	        "icon": "#1d2124",
	        "text": "#141719"
	      }
	    },
	    "secondary": {
	      "critical": {
	        "background": "#ea8aa3",
	        "border": "#b23655",
	        "icon": "#ffd1dd",
	        "iconAlt": "#1d2124",
	        "text": "#ffd1dd",
	        "textAlt": "#141719"
	      },
	      "inverse": {
	        "border": "#1d2124",
	        "icon": "#1d2124",
	        "text": "#141719"
	      },
	      "neutral": {
	        "border": "#f7f7f7",
	        "icon": "#e8e9ea",
	        "text": "#ffffff"
	      },
	      "smart": {
	        "icon": "#e8e9ea",
	        "iconAlt": "#141719",
	        "text": "#ffffff",
	        "textAlt": "#141719"
	      }
	    },
	    "ssoButton": {
	      "apple": {
	        "background": "#ffffff",
	        "border": "#ffffff",
	        "icon": "#000000",
	        "text": "#000000"
	      },
	      "borderWeight": "1px",
	      "gap": "12px",
	      "google": {
	        "background": "#f2f2f2",
	        "border": "#f2f2f2",
	        "icon": {
	          "blue": "#4285f4",
	          "green": "#34a853",
	          "red": "#ea4335",
	          "yellow": "#fbbc05"
	        },
	        "text": "#1f1f1f"
	      },
	      "height": "44px",
	      "padding": "16px",
	      "radius": "8px"
	    },
	    "tertiary": {
	      "inverse": {
	        "icon": "#1d2124",
	        "text": "#141719"
	      },
	      "neutral": {
	        "icon": "#e8e9ea",
	        "text": "#ffffff"
	      }
	    },
	    "width": {
	      "large": "52px",
	      "medium": "44px",
	      "small": "34px"
	    }
	  },
	  "carousel": {
	    "gap": "12px",
	    "pagination": {
	      "background": {
	        "default": "#515357",
	        "selected": "#f7f7f7"
	      },
	      "gap": "8px",
	      "height": {
	        "medium": "8px",
	        "small": "4px"
	      },
	      "width": {
	        "medium": "28px",
	        "small": "8px"
	      }
	    }
	  },
	  "checkbox": {
	    "background": {
	      "default": "#141719",
	      "selected": "#f7f7f7"
	    },
	    "border": "#98999b",
	    "borderRadius": "3px",
	    "borderWeight": "1.5px",
	    "gap": "2px",
	    "height": {
	      "large": "34px",
	      "small": "18px"
	    },
	    "icon": "#1d2124",
	    "text": "#e8e9ea",
	    "width": {
	      "large": "34px",
	      "small": "18px"
	    }
	  },
	  "chip": {
	    "background": "#141719",
	    "border": "#686b70",
	    "borderRadius": "8px",
	    "borderWeight": "1px",
	    "gap": {
	      "small": "8px",
	      "xsmall": "4px"
	    },
	    "height": "34px",
	    "icon": "#e8e9ea",
	    "iconHeight": "16px",
	    "iconWidth": "16px",
	    "multi": {
	      "background": {
	        "selected": "#515357"
	      }
	    },
	    "paddingL": {
	      "medium": "12px",
	      "small": "8px"
	    },
	    "paddingR": {
	      "medium": "12px",
	      "small": "8px"
	    },
	    "paddingX": "12px",
	    "single": {
	      "background": {
	        "selected": "#e8e9ea"
	      },
	      "text": {
	        "selected": "#1d2124"
	      }
	    },
	    "text": "#ffffff"
	  },
	  "divider": {
	    "border": "#515357",
	    "borderWeight": "1px",
	    "gap": "16px",
	    "height": "1px",
	    "text": "#bcbdbf"
	  },
	  "drawer": {
	    "background": {
	      "fixed": "#2d3238",
	      "surface": "#2d3238"
	    },
	    "borderRadius": "16px",
	    "gap": {
	      "medium": "16px",
	      "small": "8px"
	    },
	    "paddingL": "8px",
	    "paddingX": "16px",
	    "paddingY": "16px",
	    "textSubtitle": "#e8e9ea",
	    "textTitle": "#ffffff"
	  },
	  "dropdown": {
	    "borderRadius": {
	      "medium": "8px",
	      "small": "4px"
	    },
	    "destructive": {
	      "item": {
	        "icon": "#ffd1dd",
	        "text": "#ffd1dd"
	      }
	    },
	    "gap": {
	      "medium": "8px",
	      "small": "4px"
	    },
	    "height": {
	      "medium": "34px"
	    },
	    "neutral": {
	      "icon": "#e8e9ea",
	      "selected": "#515357",
	      "textBody": "#e8e9ea",
	      "textTitle": "#ffffff"
	    },
	    "paddingTop": "8px",
	    "paddingX": {
	      "medium": "8px",
	      "small": "4px"
	    },
	    "paddingY": {
	      "medium": "8px",
	      "xsmall": "2px"
	    },
	    "surface": "#2d3238"
	  },
	  "emptyState": {
	    "background": "#141719",
	    "border": "#686b70",
	    "borderRadius": "8px",
	    "borderWeight": "1px",
	    "gap": {
	      "medium": "16px",
	      "small": "8px"
	    },
	    "paddingX": "40px",
	    "paddingY": "40px",
	    "textBody": "#e8e9ea",
	    "textHeading": "#ffffff"
	  },
	  "footers": {
	    "background": "#141719",
	    "gap": {
	      "large": "32px",
	      "medium": "16px",
	      "small": "8px",
	      "xlarge": "48px",
	      "xsmall": "4px",
	      "xxlarge": "144px"
	    },
	    "icon": "#e8e9ea",
	    "paddingX": {
	      "large": "32px",
	      "medium": "20px",
	      "small": "16px"
	    },
	    "paddingY": "16px",
	    "text": "#e8e9ea"
	  },
	  "icon": {
	    "alternate": {
	      "background": "#141719",
	      "icon": "#e8e9ea"
	    },
	    "backgroundHeight": {
	      "large": "64px",
	      "medium": "52px",
	      "small": "44px",
	      "xsmall": "34px"
	    },
	    "backgroundWidth": {
	      "large": "64px",
	      "medium": "52px",
	      "small": "44px",
	      "xsmall": "34px"
	    },
	    "borderRadius": {
	      "circular": "300px",
	      "rectangular": "8px"
	    },
	    "critical": {
	      "background": "#5e1d2e",
	      "icon": "#ffd1dd"
	    },
	    "discovery": {
	      "background": "#5e4317",
	      "icon": "#efe5d1"
	    },
	    "iconHeight": {
	      "large": "24px",
	      "medium": "20px",
	      "small": "16px",
	      "xsmall": "14px"
	    },
	    "iconWidth": {
	      "large": "24px",
	      "medium": "20px",
	      "small": "16px",
	      "xsmall": "14px"
	    },
	    "info": {
	      "background": "#1a3c60",
	      "icon": "#d1e8ff"
	    },
	    "inverse": {
	      "background": "#e8e9ea",
	      "icon": "#1d2124"
	    },
	    "neutral": {
	      "background": "#2d3238",
	      "icon": "#e8e9ea"
	    },
	    "recur": {
	      "background": "#482359",
	      "icon": "#f0d1ff"
	    },
	    "success": {
	      "background": "#1f5b45",
	      "icon": "#f0fff9"
	    },
	    "warning": {
	      "background": "#63371c",
	      "icon": "#ffe3d1"
	    }
	  },
	  "iconInteractive": {
	    "backgroundHeight": {
	      "large": "34px",
	      "medium": "24px",
	      "small": "20px"
	    },
	    "backgroundWidth": {
	      "large": "34px",
	      "medium": "24px",
	      "small": "20px"
	    },
	    "borderRadius": "300px",
	    "icon": "#e8e9ea"
	  },
	  "input": {
	    "background": "#141719",
	    "borderRadius": "8px",
	    "borderWeight": "1px",
	    "critical": {
	      "border": "#b23655",
	      "icon": "#ffd1dd",
	      "text": "#ffd1dd"
	    },
	    "gap": "16px",
	    "height": {
	      "large": "52px",
	      "small": "28px",
	      "xlarge": "80px"
	    },
	    "iconHeight": "24px",
	    "iconWidth": "24px",
	    "neutral": {
	      "border": "#686b70",
	      "icon": "#e8e9ea",
	      "text": "#e8e9ea"
	    },
	    "paddingX": "16px",
	    "paddingY": "16px"
	  },
	  "link": {
	    "accentGreen": {
	      "border": "#f0fff9",
	      "icon": "#f0fff9",
	      "text": "#f0fff9"
	    },
	    "borderRadius": "4px",
	    "gap": "4px",
	    "height": {
	      "small": "3px",
	      "xsmall": "1px"
	    },
	    "inverse": {
	      "border": "#1d2124",
	      "icon": "#1d2124",
	      "text": "#1d2124"
	    },
	    "neutral": {
	      "border": "#e8e9ea",
	      "icon": "#e8e9ea",
	      "text": "#e8e9ea"
	    },
	    "paddingX": "2px",
	    "paddingY": "2px"
	  },
	  "list": {
	    "height": "34px",
	    "padding": {
	      "small": "4px"
	    },
	    "paddingY": {
	      "small": "2px"
	    }
	  },
	  "message": {
	    "borderRadius": "8px",
	    "critical": {
	      "background": "#5e1d2e",
	      "icon": "#ffd1dd",
	      "textBody": "#ffd1dd",
	      "textHeading": "#feeef2"
	    },
	    "gap": {
	      "medium": "16px",
	      "small": "8px"
	    },
	    "iconHeight": "24px",
	    "iconWidth": "24px",
	    "info": {
	      "background": "#1a3c60",
	      "icon": "#d1e8ff",
	      "textBody": "#d1e8ff",
	      "textHeading": "#e6f1fc"
	    },
	    "neutral": {
	      "background": "#2d3238",
	      "icon": "#e8e9ea",
	      "textBody": "#e8e9ea",
	      "textHeading": "#ffffff"
	    },
	    "paddingX": "16px",
	    "paddingY": "16px",
	    "success": {
	      "background": "#1f5b45",
	      "icon": "#f0fff9",
	      "textBody": "#f0fff9",
	      "textHeading": "#fafffc"
	    },
	    "warning": {
	      "background": "#63371c",
	      "icon": "#ffe3d1",
	      "textBody": "#ffe3d1",
	      "textHeading": "#fff3e8"
	    }
	  },
	  "modal": {
	    "background": {
	      "fixed": "#2d3238",
	      "surface": "#2d3238"
	    },
	    "borderRadius": "16px",
	    "gap": {
	      "medium": "16px",
	      "small": "8px"
	    },
	    "paddingB": "24px",
	    "paddingT": "8px",
	    "paddingX": "24px",
	    "paddingY": "16px",
	    "textBody": "#e8e9ea",
	    "textHeading": "#ffffff"
	  },
	  "navigation": {
	    "background": {
	      "fixed": "#2d3238",
	      "static": "#141719"
	    },
	    "burger": {
	      "borderRadius": "4px",
	      "height": "24px",
	      "width": "24px"
	    },
	    "data": "#bcbdbf",
	    "gap": {
	      "large": "12px",
	      "medium": "8px",
	      "xlarge": "16px",
	      "xsmall": "4px"
	    },
	    "height": "52px",
	    "paddingT": "16px",
	    "paddingX": {
	      "medium": "16px",
	      "small": "12px",
	      "xsmall": "4px"
	    },
	    "paddingY": {
	      "medium": "16px",
	      "small": "12px",
	      "xsmall": "4px"
	    },
	    "text": "#ffffff"
	  },
	  "page": {
	    "gap": {
	      "large": "20px",
	      "medium": "16px",
	      "small": "8px",
	      "xlarge": "32px",
	      "xsmall": "4px"
	    },
	    "height": "64px",
	    "paddingB": "16px",
	    "paddingT": {
	      "medium": "16px",
	      "small": "12px"
	    },
	    "paddingX": {
	      "large": "32px",
	      "medium": "20px",
	      "small": "16px"
	    },
	    "paddingY": {
	      "medium": "16px",
	      "small": "12px"
	    },
	    "textBody": "#e8e9ea",
	    "textHeading": "#ffffff"
	  },
	  "pagination": {
	    "gap": "16px"
	  },
	  "pill": {
	    "critical": {
	      "background": "#5e1d2e",
	      "text": "#ffd1dd"
	    },
	    "discovery": {
	      "background": "#5e4317",
	      "text": "#efe5d1"
	    },
	    "gap": "4px",
	    "height": {
	      "medium": "28px",
	      "small": "24px",
	      "xsmall": "16px"
	    },
	    "info": {
	      "background": "#1a3c60",
	      "text": "#d1e8ff"
	    },
	    "neutral": {
	      "background": "#2d3238",
	      "text": "#e8e9ea"
	    },
	    "paddingX": {
	      "medium": "12px",
	      "small": "8px",
	      "xsmall": "4px"
	    },
	    "radius": "300px",
	    "recur": {
	      "background": "#482359",
	      "text": "#f0d1ff"
	    },
	    "success": {
	      "background": "#1f5b45",
	      "text": "#f0fff9"
	    },
	    "warning": {
	      "background": "#63371c",
	      "text": "#ffe3d1"
	    },
	    "width": {
	      "small": "24px"
	    }
	  },
	  "popover": {
	    "background": "#2d3238",
	    "borderRadius": "8px",
	    "borderWeight": "1px",
	    "gap": {
	      "medium": "32px",
	      "small": "16px"
	    },
	    "height": "12px",
	    "paddingT": "2px",
	    "paddingX": "16px",
	    "paddingY": "16px",
	    "textBody": "#e8e9ea",
	    "textHeading": "#ffffff",
	    "width": "20px"
	  },
	  "price": {
	    "divider": "#515357",
	    "gap": "4px",
	    "textDiscount": "#f0fff9",
	    "textRegular": "#ffffff",
	    "textSubtle": "#bcbdbf",
	    "wholesale": {
	      "divider": {
	        "height": "14px"
	      }
	    }
	  },
	  "productCard": {
	    "background": {
	      "selected": "#1d2124"
	    },
	    "borderRadius": "8px",
	    "data": "#bcbdbf",
	    "gap": {
	      "medium": "8px",
	      "small": "4px"
	    },
	    "heading": "#ffffff",
	    "height": {
	      "medium": "24px"
	    },
	    "icon": "#e8e9ea",
	    "paddingX": {
	      "medium": "8px",
	      "small": "4px"
	    },
	    "paddingY": {
	      "large": "12px",
	      "medium": "8px",
	      "small": "4px"
	    },
	    "subheading": "#bcbdbf",
	    "description": "#e8e9ea"
	  },
	  "productImage": {
	    "background": "#ffffff",
	    "border": "#686b70",
	    "borderWeight": "2px",
	    "fSbadge": {
	      "background": "#124935",
	      "gap": "8px",
	      "heightBackground": {
	        "medium": "24px",
	        "small": "16px"
	      },
	      "heightIcon": {
	        "medium": "12px",
	        "small": "8px"
	      },
	      "heightImage": {
	        "large": "146px",
	        "medium": "110px",
	        "small": "88px",
	        "xlarge": "224px",
	        "xsmall": "62px",
	        "xxlarge": "584px",
	        "xxsmall": "42px"
	      },
	      "icon": "#f0fff9",
	      "paddingY": "12px",
	      "widthBackground": {
	        "medium": "24px",
	        "small": "16px"
	      },
	      "widthIcon": {
	        "medium": "12px",
	        "small": "8px"
	      },
	      "widthImage": {
	        "large": "146px",
	        "medium": "110px",
	        "small": "88px",
	        "xlarge": "224px",
	        "xsmall": "62px",
	        "xxlarge": "584px",
	        "xxsmall": "42px"
	      }
	    },
	    "padding": "4px",
	    "radius": {
	      "large": "300px",
	      "medium": "16px",
	      "small": "8px",
	      "xsmall": "4px"
	    },
	    "status": {
	      "critical": "#451522",
	      "neutral": "#1d2124",
	      "warning": "#4a2915"
	    },
	    "text": "#f0fff9"
	  },
	  "progressbar": {
	    "background": {
	      "complete": "#42ad86",
	      "incomplete": "#515357",
	      "progress": "#e8e9ea"
	    },
	    "borderRadius": "300px",
	    "height": "8px"
	  },
	  "quantitySelector": {
	    "borderRadius": "8px",
	    "height": {
	      "medium": "44px",
	      "small": "34px"
	    },
	    "icon": "#e8e9ea",
	    "number": {
	      "gap": "4px",
	      "width": "38px"
	    }
	  },
	  "radio": {
	    "background": {
	      "default": "#141719",
	      "selected": "#f7f7f7"
	    },
	    "border": "#98999b",
	    "borderRadius": "300px",
	    "borderWeight": "1.5px",
	    "gap": "2px",
	    "height": {
	      "large": "34px",
	      "small": "20px"
	    },
	    "text": "#e8e9ea",
	    "width": {
	      "large": "34px",
	      "small": "20px"
	    }
	  },
	  "scrollBar": {
	    "paddingRight": "6px"
	  },
	  "search": {
	    "background": "#141719",
	    "border": "#686b70",
	    "borderRadius": "8px",
	    "borderWeight": "1px",
	    "gap": "8px",
	    "height": {
	      "large": "52px",
	      "medium": "44px"
	    },
	    "icon": "#e8e9ea",
	    "iconHeight": "24px",
	    "iconWidth": "24px",
	    "paddingX": "16px",
	    "text": "#e8e9ea"
	  },
	  "selectableTile": {
	    "background": {
	      "selected": "#2d3238",
	      "unselected": "#141719"
	    },
	    "border": "#686b70",
	    "borderRadius": "8px",
	    "borderWeight": "1px",
	    "gap": "16px",
	    "paddingT": "4px",
	    "paddingX": "16px",
	    "paddingY": "16px",
	    "text": "#e8e9ea"
	  },
	  "slot": {
	    "border": "#686b70",
	    "icon": "#e8e9ea",
	    "text": "#ffffff"
	  },
	  "snackbar": {
	    "borderRadius": "8px",
	    "critical": {
	      "surface": "#ea8aa3"
	    },
	    "gap": "16px",
	    "height": "56px",
	    "icon": "#1d2124",
	    "paddingT": "2px",
	    "paddingX": "16px",
	    "paddingY": "8px",
	    "success": {
	      "surface": "#42ad86"
	    },
	    "surface": "#f7f7f7",
	    "textHeading": "#141719"
	  },
	  "spacing": {
	    "gap": {
	      "large": "24px",
	      "medium": "16px",
	      "small": "8px",
	      "xlarge": "32px",
	      "xsmall": "4px",
	      "xxlarge": "48px"
	    },
	    "padding": {
	      "large": "32px",
	      "small": "16px",
	      "xsmall": "8px"
	    }
	  },
	  "status": {
	    "borderRadius": "4px",
	    "critical": {
	      "background": "#5e1d2e",
	      "icon": "#ffd1dd",
	      "text": "#feeef2"
	    },
	    "gap": "8px",
	    "height": {
	      "large": "52px",
	      "medium": "44px",
	      "small": "34px"
	    },
	    "icon": {
	      "height": "8px",
	      "radius": "300px",
	      "width": "8px"
	    },
	    "info": {
	      "background": "#1a3c60",
	      "icon": "#d1e8ff",
	      "text": "#e6f1fc"
	    },
	    "neutral": {
	      "background": "#2d3238",
	      "icon": "#e8e9ea",
	      "text": "#ffffff"
	    },
	    "paddingX": {
	      "large": "16px",
	      "medium": "16px",
	      "small": "8px"
	    },
	    "success": {
	      "background": "#1f5b45",
	      "icon": "#f0fff9",
	      "text": "#fafffc"
	    },
	    "warning": {
	      "background": "#63371c",
	      "icon": "#ffe3d1",
	      "text": "#fff3e8"
	    }
	  },
	  "stepper": {
	    "background": {
	      "complete": "#42ad86",
	      "error": "#ea8aa3"
	    },
	    "border": {
	      "active": "#288563",
	      "incomplete": "#686b70"
	    },
	    "borderRadius": "300px",
	    "circle": {
	      "height": "20px",
	      "width": "20px"
	    },
	    "gap": "0px",
	    "label": "#e8e9ea",
	    "paddingX": "4px"
	  },
	  "table": {
	    "background": {
	      "header": "#2d3238",
	      "row": "#1d2124",
	      "selected": "#1d2124"
	    },
	    "border": "#515357",
	    "cell": {
	      "height": {
	        "min": "44px"
	      },
	      "paddingX": "12px",
	      "paddingY": {
	        "medium": "12px",
	        "small": "4px"
	      },
	      "width": {
	        "min": "88px"
	      }
	    },
	    "gap": {
	      "medium": "8px",
	      "small": "4px"
	    },
	    "label": "#ffffff",
	    "paddingY": {
	      "large": "24px",
	      "small": "8px"
	    },
	    "text": "#e8e9ea"
	  },
	  "tabs": {
	    "background": "#2d3238",
	    "borderRadius": {
	      "medium": "8px"
	    },
	    "gap": "4px",
	    "paddingX": {
	      "medium": "8px",
	      "small": "4px"
	    },
	    "paddingY": {
	      "small": "4px"
	    },
	    "selected": {
	      "background": "#141719",
	      "text": "#ffffff"
	    },
	    "unselected": {
	      "text": "#e8e9ea"
	    }
	  },
	  "toggle": {
	    "button": {
	      "colour": "#141719",
	      "height": "24px",
	      "paddingX": "2px",
	      "paddingY": "2px",
	      "width": "24px"
	    },
	    "gap": "12px",
	    "icon": {
	      "height": "16px",
	      "icon": "#e8e9ea",
	      "width": "16px"
	    },
	    "radius": "300px",
	    "text": "#e8e9ea",
	    "track": {
	      "backgroundOff": "#515357",
	      "backgroundOn": "#42ad86",
	      "height": "32px",
	      "track": "52px"
	    }
	  },
	  "tooltip": {
	    "borderRadius": "4px",
	    "height": "8px",
	    "inverse": {
	      "background": "#1d2124",
	      "text": "#e8e9ea"
	    },
	    "neutral": {
	      "background": "#f7f7f7",
	      "text": "#1d2124"
	    },
	    "paddingX": "8px",
	    "paddingY": "4px",
	    "width": "12px"
	  },
	  "user": {
	    "gap": {
	      "large": "16px",
	      "medium": "8px",
	      "small": "2px"
	    },
	    "paddingX": "2px",
	    "radius": "4px",
	    "textInverse": "#1d2124",
	    "textNeutral": "#e8e9ea",
	    "widthMin": {
	      "large": "300px",
	      "medium": "260px",
	      "small": "210px"
	    }
	  }
	};
	
	return darkDesktop1280;
}

exports.__require = requireDarkDesktop1280;
//# sourceMappingURL=dark-desktop1280.cjs.map
